<template>
  <div>
    <div class="flex justify-between mb-8">
      <select v-model="segment" class="btn">
        <option
          v-for="option in sections"
          :key="option.name"
          :value="option.name"
        >
          {{ option.name }}
        </option>
      </select>
    </div>
    <ColumnChart
      class="h-72"
      :data="barChartData"
      :max="max"
      :average="average"
      :color="color"
      @hover="$event ? showTooltip($event) : hideTooltip()"
    />
    <VTooltip :show="tooltip.show" :target="tooltip.target" class="z-30">
      <div
        class="bg-black bg-opacity-80 text-white px-4 py-2 rounded-lg text-xs flex items-center"
      >
        <div class="">
          <div class="font-bold">{{ tooltip.title }}</div>
          <div>{{ tooltip.value }}</div>
        </div>
      </div>
    </VTooltip>
  </div>
</template>

<script>
import data from "@/assets/data/data";
import IDS from "@/utils/ids";
import colors from "@/utils/colors";
import { max } from "d3";

import ColumnChart from "@/components/ColumnChart";
import VTooltip from "@/components/VTooltip";

export default {
  components: {
    ColumnChart,
    VTooltip,
  },
  props: {
    question: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      data: data[this.question][0],
      sections: IDS.SEGMENTS_SECTIONS.filter((e) => e.name !== "Total"),
      segment: "Por sexo",
      questionText: this.$t(`questions.${this.question}.question`),
      tooltip: {
        show: false,
        left: 0,
        top: 0,
        bottom: 0,
        html: "",
        title: "",
        target: null,
      },
      color: colors.secondaryYellow,
    };
  },
  computed: {
    segments() {
      return this.sections.find((e) => e.name === this.segment).segments;
    },
    barChartData() {
      return this.segments.map((e) => ({ name: e, value: this.data[e] }));
    },
    average() {
      return this.data["Total"];
    },
    max() {
      const segments = ["Total"];
      this.sections.forEach((section) => segments.push(...section.segments));
      return max(segments.map((e) => this.data[e]));
    },
  },
  methods: {
    showTooltip({ event: { target }, data }) {
      this.tooltip.target = target;

      this.tooltip.value = this.$options.filters.number(data.value, 0);
      this.tooltip.title = data.name;

      this.tooltip.show = true;
    },
    hideTooltip() {
      this.tooltip.show = false;
    },
  },
};
</script>
